import { gql } from '@apollo/client';

export const fetchPartnerBillingAdminIds = gql`
  query fetchPartnerBillingAdminIds($id: ID!) {
    transactionAccount(id: $id) {
      partnerBillingAdminIds
    }
  }
`;
